export default __webpack_public_path__ + "static/media/Cashback.7331ffff.svg";